export const conversionReportGrid = [
  {
    column: "regionDescription",
    width: "176px",
    title: "Region",
    filter: "text",
    isShown: true
  },
  {
    column: "marketDescription",
    width: "176px",
    title: "Market",
    filter: "text",
    isShown: true
  },
  {
    column: "brandDescription",
    width: "176px",
    title: "Brand",
    filter: "text",
    isShown: true
  },
  {
    column: "branchDescription",
    width: "176px",
    title: "Branch",
    filter: "text",
    isShown: true
  },
  {
    column: "campaign",
    width: "176px",
    title: "Campaign",
    filter: "numeric",
    isShown: true
  },
  {
    column: "customerLead",
    width: "176px",
    title: "Customer Leads",
    filter: "numeric",
    isShown: true
  },
  {
    column: "contacted",
    width: "176px",
    title: "Contacted",
    filter: "numeric",
    isShown: true
  },
  {
    column: "formattedContacted",
    width: "200px",
    title: "Contacted p",
    filter: "numeric",
    isShown: true
  },
  {
    column: "contactedMthsElapsed",
    width: "280px",
    title: "Contacted Months Elapsed",
    filter: "numeric",
    isShown: true
  },
  {
    column: "formattedContactedPercentageElapsed",
    width: "300px",
    title: "Contacted p Elapsed",
    filter: "numeric",
    isShown: true
  },
  {
    column: "appointed",
    width: "176px",
    title: "Appointed",
    filter: "numeric",
    isShown: true
  },
  {
    column: "formattedAppointed",
    width: "250px",
    title: "Appointed p",
    filter: "numeric",
    isShown: true
  },
  {
    column: "appointmentAttended",
    width: "250px",
    title: "Appointment Attended",
    filter: "numeric",
    isShown: true
  },
  {
    column: "formattedAppointmentAttended",
    width: "250px",
    title: "Appointment Attended p",
    filter: "numeric",
    isShown: true
  },
  {
    column: "unableToContact",
    width: "176px",
    title: "Unable to Contact",
    filter: "numeric",
    isShown: true
  },
  {
    column: "futureOpportunity",
    width: "176px",
    title: "Future Opportunity",
    filter: "numeric",
    isShown: true
  },
  {
    column: "closedLost",
    width: "176px",
    title: "Closed/Lost",
    filter: "numeric",
    isShown: true
  },
  {
    column: "formattedClosedLost",
    width: "176px",
    title: "Closed/Lost p",
    filter: "numeric",
    isShown: true
  },
  {
    column: "doNotContact",
    width: "176px",
    title: "Do Not Contact",
    filter: "numeric",
    isShown: true
  },
  {
    column: "sold",
    width: "176px",
    title: "Sold",
    filter: "numeric",
    isShown: true
  },
  {
    column: "formattedSold",
    width: "176px",
    title: "Sold p",
    filter: "numeric",
    isShown: true
  },
  {
    column: "soldMthsElapsed",
    width: "250px",
    title: "Sold Months Elapsed",
    filter: "numeric",
    isShown: true
  },
  {
    column: "formattedSoldPercentageElapsed",
    width: "215px",
    title: "Sold p Elapsed",
    filter: "numeric",
    isShown: true
  },
  {
    column: "formattedFinalOutCome",
    width: "200px",
    title: "Final Outcome Rate",
    filter: "numeric",
    isShown: true
  }
];
